export default __webpack_public_path__ + "static/media/topic930bg.1b35559c.png";